<template functional>
  <p>{{props.message}}</p>
</template>

<script>
export default {
  name: 'MessageModal',

  props: {
    message: {
      type: String,
      required: true
    }
  }
}
</script>
